import "./PolicyPage.css";

const englishSections = [
  {
    title: "1. Controller",
    content:
      "The responsible entity for data processing is:\n\nLars Hamburger\nEulengasse 15\n60385 Frankfurt am Main\nGermany\nEmail: getit.lhamb@gmail.com",
  },
  {
    title: "2. No Personal Data Collection",
    content:
      "We do not collect, store, or process any personal data through the app or this website.\n\nThe app does not require user registration and does not include tracking, analytics, or advertising services.",
  },
  {
    title: "3. Server Log Files",
    content:
      "When you access this website, your browser may automatically transmit certain information to the hosting provider.\n\nThis may include:\n\n• IP address\n• Browser type and version\n• Operating system\n• Date and time of access\n\nThis data is used solely to ensure the proper operation and security of the website and is not used to identify individuals.",
  },
  {
    title: "4. No Cookies",
    content:
      "This website does not use cookies or similar tracking technologies.",
  },
  {
    title: "5. Third-Party Services",
    content: "We do not use third-party services that collect personal data.",
  },
  {
    title: "6. Your Rights",
    content:
      "Under applicable data protection laws (such as the GDPR), you have the right to request information about your data, its correction, or deletion.\n\nSince we do not collect personal data, such requests typically do not apply.",
  },
  {
    title: "7. Contact",
    content:
      "If you have any questions about this Privacy Policy, you can contact:\n\nEmail: getit.lhamb@gmail.com\nWebsite: larshamburger.com",
  },
];

const germanSections = [
  {
    title: "1. Verantwortlicher",
    content:
      "Verantwortlich für die Datenverarbeitung ist:\n\nLars Hamburger\nEulengasse 15\n60385 Frankfurt am Main\nDeutschland\nE-Mail: getit.lhamb@gmail.com",
  },
  {
    title: "2. Keine Erhebung personenbezogener Daten",
    content:
      "Wir erheben, speichern oder verarbeiten keine personenbezogenen Daten über die App oder diese Website.\n\nDie App erfordert keine Registrierung und enthält keine Tracking-, Analyse- oder Werbedienste.",
  },
  {
    title: "3. Server-Logfiles",
    content:
      "Beim Zugriff auf diese Website kann Ihr Browser automatisch bestimmte Informationen an den Hosting-Anbieter übermitteln.\n\nDies kann Folgendes umfassen:\n\n• IP-Adresse\n• Browsertyp und Browserversion\n• Betriebssystem\n• Datum und Uhrzeit des Zugriffs\n\nDiese Daten werden ausschließlich zur Gewährleistung des ordnungsgemäßen Betriebs und der Sicherheit der Website verwendet und nicht zur Identifizierung einzelner Personen genutzt.",
  },
  {
    title: "4. Keine Cookies",
    content:
      "Diese Website verwendet keine Cookies oder ähnliche Tracking-Technologien.",
  },
  {
    title: "5. Dienste von Drittanbietern",
    content:
      "Wir verwenden keine Dienste von Drittanbietern, die personenbezogene Daten erheben.",
  },
  {
    title: "6. Ihre Rechte",
    content:
      "Nach geltenden Datenschutzgesetzen (z. B. der DSGVO) haben Sie das Recht, Auskunft über Ihre Daten sowie deren Berichtigung oder Löschung zu verlangen.\n\nDa wir keine personenbezogenen Daten erheben, sind solche Anfragen in der Regel nicht anwendbar.",
  },
  {
    title: "7. Kontakt",
    content:
      "Wenn Sie Fragen zu dieser Datenschutzerklärung haben, können Sie uns kontaktieren:\n\nE-Mail: getit.lhamb@gmail.com\nWebsite: larshamburger.com",
  },
];

function renderSection(section) {
  return (
    <article key={section.title} className="policy-page__section">
      <h2 className="policy-page__section-title">{section.title}</h2>
      <div className="policy-page__section-content">
        {section.content.split("\n\n").map((paragraph, index) => (
          <p key={`${section.title}-${index}`}>{paragraph}</p>
        ))}
      </div>
    </article>
  );
}

function PolicyPage() {
  return (
    <section className="policy-page">
      <h1 className="policy-page__title">Privacy Policy</h1>
      <p className="policy-page__meta">Effective Date: February 1, 2026</p>
      <p className="policy-page__intro">
        This Privacy Policy applies to both the website and the mobile
        application “Get It? – The Party Game”.
      </p>

      <div className="policy-page__sections">
        {englishSections.map(renderSection)}
      </div>

      <h1 className="policy-page__title policy-page__title--secondary">
        Datenschutzerklärung (Deutsch)
      </h1>
      <p className="policy-page__meta">Gültig ab: 1. Februar 2026</p>
      <p className="policy-page__intro">
        Diese Datenschutzerklärung gilt sowohl für die Website als auch für die
        mobile Anwendung „Get It? – The Party Game“.
      </p>

      <div className="policy-page__sections">
        {germanSections.map(renderSection)}
      </div>
    </section>
  );
}

export default PolicyPage;
